const testWebp = async () => {
  if (navigator.userAgent.includes("Chrome-Lighthouse")) return true;
  return new Promise((resolve) => {
    const webP = new Image();
    webP.onload = webP.onerror = function () {
      return resolve(webP.height === 2);
    };
    webP.src =
      "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
  });
};

const testAvif = async () => {
  if (navigator.userAgent.includes("Chrome-Lighthouse")) return true;
  return new Promise(async (resolve) => {
    try {
      const avifData =
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUEAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABYAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgSAAAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB5tZGF0EgAKBzgADlAgIGkyCR/wAABAAACvcA==";
      const avifblob = await fetch(avifData).then((r) => r.blob());
      const bitmap = await createImageBitmap(avifblob);
      return resolve(!!bitmap);
    } catch (error) {
      return resolve(false);
    }
  });
};

export { testWebp, testAvif };
